import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./appointment_success_popup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { appointmentOptions } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
import CloseButton from "../../closeButton/closeButton";
import i18n from "../../../i18n";

interface ISupportSuccessPopup extends IPopupWithoutProps {
  type: appointmentOptions;
}
function AppointmentSuccessPopup({
  onClose,
  type = appointmentOptions.Create,
}: ISupportSuccessPopup) {
  const title =
    type === appointmentOptions.Create
      ? t('MEETING_CREATED_SUCCESSFULLY')
      : type === appointmentOptions.Update
      ? t('MEETING_SUCCESSFULLY_CHANGED')
      : t('MEETING_CANCELLED_SUCCESS');

  const navigate = useNavigate();

  return (
    <article className={popupStyles.popup} style={{ direction: i18n.dir() }}>
      <CloseButton onClick={onClose} />
      <h2 className={popupStyles.popup__title}>{title}</h2>
      <p className={popupStyles.popup__text}>
        {t('MEETING_SCHEDULE_ACCESS')}</p>
      <img
        src={doctor}
        alt={t('IMAGE_OF_VENUS')}
        className={popupStyles.popup__img}
      />
      <button
        className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btn_type_calendar} hover`}
        onClick={() => {
          navigate("/treatment", {
            replace: true,
            state: { pathname: "myCalendar" },
          });
          onClose();
        }}
      >
        {t('MEETING_CALENDAR_AREA')}</button>
      <button
        className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btn_disabled} hover`}
        onClick={() => {
          navigate("/treatment/search");
          onClose();
        }}
        disabled={true}
      >
        {t('SCHEDULE_ANOTHER_MEETING')}</button>
    </article>
  );
}

export default AppointmentSuccessPopup;
